export const json_tree_theme = {
  scheme: 'monokai',
  author: 'wimer hazenberg (http://www.monokai.nl)',
  base00: '#272822',
  base01: '#383830',
  base02: '#49483e',
  base03: '#97B38C',
  base04: '#a59f85',
  base05: '#f8f8f2',
  base06: '#f5f4f1',
  base07: '#f9f8f5',
  base08: '#f92672',
  base09: '#fd971f',
  base0A: '#f4bf75',
  base0B: '#83C7DD',
  base0C: '#a1efe4',
  base0D: '#fff',
  base0E: '#ae81ff',
  base0F: '#cc6633',
  padding: '200',
};